import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { kebabCase } from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import Icon from '../common/containers/icon';
import { formatCabinetCellValue } from '../../utils/cabinetColumnUtils';
const getRowDisplay = (indexes, index, data) => {
  if (indexes && indexes.length) {
    return indexes.map(currentIndex => "".concat(formatCabinetCellValue(data[currentIndex]), " "));
  }
  return formatCabinetCellValue(data[index]);
};
const CabinetRow = _ref => {
  let id = _ref.id,
    columns = _ref.columns,
    data = _ref.data,
    onClick = _ref.onClick,
    onSelect = _ref.onSelect,
    rowIndex = _ref.rowIndex,
    _ref$hasActions = _ref.hasActions,
    hasActions = _ref$hasActions === void 0 ? false : _ref$hasActions,
    _ref$isSelected = _ref.isSelected,
    isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected,
    _ref$isDeleted = _ref.isDeleted,
    isDeleted = _ref$isDeleted === void 0 ? false : _ref$isDeleted;
  const handleClick = onClick.bind(null, id);
  const handleSelect = event => onSelect(id, event);
  let checkbox;
  if (hasActions) {
    checkbox = /*#__PURE__*/React.createElement("td", {
      "aria-label": "select-row-checkbox",
      style: {
        width: '1px',
        verticalAlign: 'middle'
      }
    }, /*#__PURE__*/React.createElement("input", {
      className: "t-cr-check",
      "data-testid": "t-cr-check-".concat(id),
      type: "checkbox",
      checked: isSelected,
      onChange: handleSelect
    }));
  }
  const renderCellContent = (_ref2, cellData) => {
    let _ref2$style = _ref2.style,
      style = _ref2$style === void 0 ? '' : _ref2$style,
      icon = _ref2.icon,
      index = _ref2.index,
      indexes = _ref2.indexes,
      color = _ref2.color;
    const value = getRowDisplay(indexes, index, cellData);
    if (style === 'iconIfPresent' && cellData[index]) {
      return /*#__PURE__*/React.createElement(Icon, {
        style: {
          textAlign: 'center',
          fontSize: '24px',
          color
        },
        glyph: icon
      });
    }
    if (style === 'smallText') {
      return /*#__PURE__*/React.createElement("small", null, value);
    }
    if (style === 'largeDate' && value) {
      return /*#__PURE__*/React.createElement("span", null, moment(value).format('MM/DD/YYYY'));
    }
    if (style === 'smallDate' && value) {
      return /*#__PURE__*/React.createElement("small", null, moment(value).format('MM/DD/YYYY'));
    }
    if (style === 'largeDateTime' && value) {
      return /*#__PURE__*/React.createElement("span", null, moment(value).format('MM/DD/YYYY HH:mm'));
    }
    if (style === 'smallDateTime' && value) {
      return /*#__PURE__*/React.createElement("small", null, moment(value).format('MM/DD/YYYY HH:mm'));
    }
    return value;
  };

  /* eslint-disable no-nested-ternary */
  return /*#__PURE__*/React.createElement("tr", {
    "data-testid": "cabinet-row-".concat(id),
    className: "t-cr-".concat(rowIndex),
    style: {
      height: '30px'
    }
  }, checkbox, columns.map(_ref3 => {
    let align = _ref3.align,
      rows = _ref3.rows,
      title = _ref3.title,
      width = _ref3.width;
    return /*#__PURE__*/React.createElement("td", {
      key: "col-".concat(rowIndex, "-").concat(kebabCase(title), "}-").concat(data.id),
      style: _objectSpread({
        textAlign: align || 'left'
      }, isDeleted ? {
        opacity: 0.5,
        cursor: 'default'
      } : {}),
      width: width
    }, rows.map(_ref4 => {
      let icon = _ref4.icon,
        index = _ref4.index,
        indexes = _ref4.indexes,
        _ref4$style = _ref4.style,
        style = _ref4$style === void 0 ? '' : _ref4$style,
        color = _ref4.color;
      return /*#__PURE__*/React.createElement("div", {
        className: "t-cr-".concat(data.id, "-").concat(kebabCase(title)),
        key: "div-".concat(rowIndex, "-").concat(index || indexes.join(''), ")}-").concat(data.id),
        role: isDeleted ? undefined : 'link',
        tabIndex: isDeleted ? undefined : '0',
        onClick: isDeleted ? undefined : handleClick,
        onKeyPress: isDeleted ? undefined : handleClick
      }, renderCellContent({
        style,
        icon,
        index,
        indexes,
        color
      }, data));
    }));
  }));
  /* eslint-enable no-nested-ternary */
};
CabinetRow.propTypes = {
  id: PropTypes.string.isRequired,
  columns: PropTypes.arrayOf(PropTypes.shape({
    rows: PropTypes.arrayOf(PropTypes.shape({
      index: PropTypes.string,
      indexes: PropTypes.arrayOf(PropTypes.string),
      style: PropTypes.string
    }))
  })).isRequired,
  data: PropTypes.shape({
    id: PropTypes.string
  }).isRequired,
  hasActions: PropTypes.bool,
  isDeleted: PropTypes.bool,
  isSelected: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  rowIndex: PropTypes.number.isRequired
};
export default CabinetRow;